import { render, staticRenderFns } from "./bot_qc.vue?vue&type=template&id=055332d1&scoped=true&"
import script from "./bot_qc.vue?vue&type=script&lang=js&"
export * from "./bot_qc.vue?vue&type=script&lang=js&"
import style0 from "./bot_qc.vue?vue&type=style&index=0&id=055332d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055332d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VCombobox,VIcon,VRow,VSelect,VTextarea,VTooltip})
